import React from 'react';
import { InlineNotification } from '../../../molecules/InlineNotification/InlineNotification';
import { Text } from '../../../atoms/Text/Text';
import './ExcludedItemsNoticeStyles.scss';
const baseClass = 'qmb-ui-excluded-items-notice';
/**
 * Names the requested actions the server refused before building an approval
 * card (IP-16494), with the reason for each — so approving cannot be mistaken
 * for approving everything that was asked for. Shared by every approval card.
 */
export function ExcludedItemsNotice({ items }) {
    if (!items || items.length === 0)
        return null;
    const title = items.length === 1 ? '1 requested action won’t be included' : `${items.length} requested actions won’t be included`;
    return (React.createElement(InlineNotification, { variant: "warning", title: title, className: baseClass },
        React.createElement("ul", { className: `${baseClass}__list` }, items.map((item, i) => (React.createElement("li", { key: `${item.label}-${i}`, className: `${baseClass}__item` },
            React.createElement(Text, { variant: "body", className: `${baseClass}__label` }, item.label),
            React.createElement(Text, { variant: "body", className: `${baseClass}__reason` }, item.reason)))))));
}
/** Plain-text lines for the card's copy action. */
export function excludedItemsCopyLines(items) {
    if (!items || items.length === 0)
        return [];
    return ['Not included:', ...items.map((item) => `- ${item.label}: ${item.reason}`)];
}
